<template>
  
  <body>
    <p>Kilka moich zdjęć ...</p>
    <br /><br />
    <div class="row">
      <div class="column">
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/ulica.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/most.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/lodka.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/focus.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/wachlarz.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/ulica.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/most.jpg" style="width:100%" />
        </div>
      </div>
      <div class="column">
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/amg.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/fordy.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/focus.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/lodka.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/wachlarz.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/ulica.jpg" style="width:100%" />
        </div>
        <div class="image">
          <!-- <p>MJ</p> -->
          <img src="@/assets/most.jpg" style="width:100%" />
        </div>
      </div>
      <div class="column">
        <div class="image">
          <img src="@/assets/vette.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/lex.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/lexu.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/focus.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/wachlarz.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/ulica.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/most.jpg" style="width:100%" />
        </div>
      </div>
      <div class="column">
        <div class="image">
          <img src="@/assets/e36.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/subbie.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/lodka.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/focus.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/wachlarz.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/ulica.jpg" style="width:100%" />
        </div>
        <div class="image">
          <img src="@/assets/most.jpg" style="width:100%" />
        </div>
      </div>
    </div>
  
   <p style="text-align:right;"> MJ</p>
    <!-- <div class="events"> -->
    <!-- <EventCard v-for="event in events" :key="event.id" :event="event" /> -->
    <!-- </div> -->
  </body>
</template>

<script>
//import EventCard from '@/components/EventCard.vue'
import EventService from '@/services/EventService.js'

export default {
  name: 'EventList',
  components: {
    //EventCard
  },
  data() {
    return {
      events: null
    }
  },
  created() {
    EventService.getEvents()
      .then(response => {
        this.events = response.data
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.events {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #2c3e50;
}
h1 {
  color: #111;
  font-family: 'Helvetica Neue', sans-serif;
  /* font-size: 275px; */
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 1;
  text-align: center;
}

/* images */
.image{
  width: 100%;
  max-width: 400px;
  height: auto;
  border: 1px solid;
  border-radius: 4px;
  padding: 5px;
}
img:hover {
  box-shadow: 0 0 2px 1px rgba(74, 145, 168, 0.5);
}
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: Arial;
}

.header {
  text-align: center;
  padding: 32px;
}

.row {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  -ms-flex-wrap: wrap; /* IE10 */
  flex-wrap: wrap;
  padding: 0 4px;
}

/* Create four equal columns that sits next to each other */
.column {
  -ms-flex: 25%; /* IE10 */
  flex: 25%;
  max-width: 25%;
  padding: 0 4px;
}

.column img {
  /* margin-top: 8px; */
  vertical-align: middle;
  width: 100%;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column {
    -ms-flex: 50%;
    flex: 50%;
    max-width: 50%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    -ms-flex: 100%;
    flex: 100%;
    max-width: 100%;
  }
}
/* watermark */

.imagea {
/* the image you want to 'watermark' */
height: auto; /* or whatever, equal to the image you want 'watermarked' */
width: auto; /* as above */
/* background-image: '@src/assets/focus.jpg'; */
/* background-position: 0 0; */
/* background-repeat: no-repeat; */
position: relative;
}

.imagea img {
/* the actual 'watermark' */
position: absolute;
top: 0; /* or whatever */
left: 0; /* or whatever, position according to taste */
opacity: 0.5; /* Firefox, Chrome, Safari, Opera, IE >= 9 (preview) */
filter:alpha(opacity=50); /* for <= IE 8 */
}

/* text */
p {
  display: inline-block;
  color: rgb(211, 211, 211);
  font-family: 'Righteous', serif;
  font-size: 2em; 
  text-shadow: .10em .10em .10em rgb(175, 39, 39);
  }
  h1:after {
    content: attr(data-shadow);
    position: absolute;
    top: .06em; left: .06em;
    z-index: -1;
    text-shadow:cornsilk;
    background-image:
      linear-gradient(
        45deg,
        transparent 45%,
        hsla(48,20%,90%,1) 45%,
        hsla(48,20%,90%,1) 55%,
        transparent 0
        );
    background-size: .05em .05em;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  
    animation: shad-anim 15s linear infinite;
    }

@keyframes shad-anim {
  10% {background-position: 0 0}
  10% {background-position: 100% -100%}
  
}
</style>
